import React, { Component } from 'react'
import { connect } from 'react-redux'

import General from '../components/SolicitudBI/General'
import Proveedores from '../components/SolicitudBI/Proveedores'
import Cotizaciones from '../components/SolicitudBI/Cotizaciones'
import Aprobaciones from '../components/SolicitudBI/Aprobaciones'
import Documentos from '../components/SolicitudBI/Documentos'
import CompraDirecta from '../components/SolicitudBI/CompraDirecta'
import Cancelacion from "../components/SolicitudBI/Cancelacion";
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'

//import { showModalConfirmarAccion } from '../actions/common'
import { getSolicitud, updateSolicitudBI, registerCancelacion } from '../actions/solicitudbi'


import { 
    canmbiarResponsable,
    showModalConfirmarAccion,
    getParameterByName
} from '../actions/common'

import history from '../utils/history'

import { isAllowedToViewComponent } from '../utils/helpers'


class SolicitudBI extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tabs: [
                { id: 0, caption: 'Solicitud', component: <General />, estado: 1 },
                { id: 1, caption: 'Proveedores', component: <Proveedores />, estado: 8 },
                { id: 2, caption: 'Cotizaciones', component: <Cotizaciones />, estado: 2 },
                { id: 3, caption: 'Aprobaciones', component: <Aprobaciones />, estado: 3 },
                { id: 4, caption: 'Documentos', component: <Documentos />, estado: 4 },
                { id: 5, caption: 'Compra directa', component: <CompraDirecta />, estado: 4 },
                { id: 6, caption: 'Cancelación', component: <Cancelacion />, estado: 0 },
            ],
            selected: 0
        }
    }

    componentWillMount() {
        if (this.props.match.params.id) {
            this.props.getSolicitud(this.props.match.params.id)
            const params = new URLSearchParams(this.props.location.search);
            if (params.has("aprobacion")) {
                this.setState({selected: 3})
            }
            this.props.getParameterByName('DIVISAS')
        } else {
            history.push(window.FOLDER + '/solicitudes')
        }
    }

    cancel = () => {
        this.props.showModalConfirmarAccion(true, `¿Está seguro que desea cancelar la solicitud?`, () => { this.props.showModalConfirmarAccion(false); this.props.registerCancelacion() })
    }

    selectTab = (e, tab) => {
        e.preventDefault()
        this.setState({ selected: tab })
    }

    render() {

        const { tabs, selected } = this.state

        const { estado, btnSaveDisabled, aprobadores, btnRComprasDisabled, solicitud, p_almacen, tipo_almacen, user } = this.props  



        let responsable_almacen = null;
        if (p_almacen && p_almacen.count() > 0) {
            responsable_almacen = p_almacen.filter(a => a.get('ALMACEN') === tipo_almacen).getIn(['0', 'USUARIO']);
        }

        const esResponsableAlmacen = responsable_almacen == user.get('username') || user.get('es_superusuario')
        const esResponsableCompras = solicitud.getIn(['responsable_compras', 'id']) == user.get('id')
        const readOnly = !isAllowedToViewComponent('responsable_compras', solicitud) 

        const documentos_proceso = solicitud.get('documentos') ? solicitud.get('documentos').filter(d => d.get('estado') == 4 || d.get('estado') > 6).count() : 0

        const facturas_directas = solicitud.get('bienes') ? solicitud.get('bienes').filter(b => b.get('factura_compra_directa') && b.get('compra_directa')).count() : 0


        const boxActions = [
            <BoxButton key="ba[0][1]" name="floppy-o" onClick={() => this.props.updateSolicitudBI()} title="Actualizar solicitud" disabled={(btnSaveDisabled && solicitud.get('estado') != 1) || (solicitud.get('estado')==1 && !esResponsableAlmacen && !esResponsableCompras)} />,
            <BoxButton key="ba[0][2]" name="user" onClick={() => this.props.canmbiarResponsable(solicitud, 'ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION')} title="Cambiar responsable" disabled={btnRComprasDisabled || selected !== 0} />,
            <BoxButton key="ba[0][5]" name="ban" onClick={() => this.cancel()} title="Aprobar cancelación solicitud" disabled={ readOnly || selected !== 6 || estado == 0} />
        ]

        

        return (
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <div className="nav-container">
                        <div className="nav-tabs-section">
                            <ul className="nav-tabs-tabs">
                                {
                                    tabs.filter(x => {

                                        if (solicitud.get('documentos') && x.id === 4 && solicitud.get('documentos').count() === 0) return null;

                                        if (x.id === 3 && aprobadores.count() === 0) return null;

                                        if (estado <= 1) {
                                            const rechazos = aprobadores.filter(x => x.get('aprobaciones').filter(y => y.get('estado') == 0).count() > 0).count() > 0
                                            if (rechazos)  {
                                                return x.estado <= 3
                                            }
                                            return x.estado <= 1

                                        } else if (estado === 8) {
                                            return x.estado === 1 || x.estado === 8 || x.estado === 0
                                        } else if ((documentos_proceso > 0 || facturas_directas > 0) && x.id === 6) {
                                            return null;
                                        } else if (estado >= 2) {
                                            return x.estado <= estado || x.estado === 8
                                        }



                                    }).map(x => {
                                        return (
                                            <li key={`li01[${x.id}]`} className={selected === x.id ? 'active' : ''}>
                                                <a onClick={(e) => this.selectTab(e, x.id)}>{x.caption}</a>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                        <div className="nav-main-section">
                            <div className="">
                                <ButtonStrip actions={boxActions} />
                            </div>
                            <div className={`${selected == 2 || selected == 3 ? 'table-section-scrollable' : 'nav-main-section-scrollable'}`}>
                                {tabs[selected].component}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        btnSaveDisabled: state.solicitudBI.get('btnSaveDisabled'),
        estado: state.solicitudBI.get('estado'),
        aprobadores: state.solicitudBI.get('aprobadores'),
        btnRComprasDisabled: state.solicitudBI.get('btnRComprasDisabled'),
        solicitud: state.solicitudBI.get('solicitud'),
        p_almacen: state.common.getIn(['parametros', 'ALMACEN']),
        tipo_almacen: state.solicitudBI.get('tipo_almacen'),
        user: state.common.get('user')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getSolicitud: (id) => dispatch(getSolicitud(id)),
        updateSolicitudBI: () => dispatch(updateSolicitudBI()),
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
        canmbiarResponsable: (solicitud, type) => dispatch(canmbiarResponsable(solicitud, type)),
        registerCancelacion: () => dispatch(registerCancelacion()),
        getParameterByName: (nombre) => dispatch(getParameterByName(nombre)),

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudBI)


// WEBPACK FOOTER //
// ./src/containers/SolicitudBI.jsx